import React, { Component } from 'react';

import {StripeProvider, Elements } from 'react-stripe-elements';
import ShieldAnimation from './ShieldAnimation';

import Form from './HonorForm';

import './App.css';
import './Grid.css';
import './StripeElements.css';

// import { of } from 'rxjs';

class App extends Component {
  constructor(props) {
      super(props);
      this.state = {
          loading: false,
          loadingTexts: [
            "Processing payment...",
            "Redirecting to paypal..."
          ],
          loadingText: 0,
          
      }
      this.toggleLoading = this.toggleLoading.bind(this)

      
  }

  toggleLoading(visible,loadingText) {
    var loadingText = loadingText || 0;
    this.setState({loading: visible, loadingText: loadingText})
  }




  render() {
      const loadingClass = this.state.loading ? 'loading visible' : 'loading'

      return(
        <StripeProvider apiKey="pk_J3AuWyw29oLWCSzF4QQ7hPt5nvO6o">
          <div className="clearfix max-width mx-auto">
            <Elements>
              <Form toggleLoading={this.toggleLoading}/>
            </Elements>
            <div className={loadingClass}>
                <ShieldAnimation text={this.state.loadingTexts[this.state.loadingText]}/>
              </div>
          </div>
          
        </StripeProvider>
      )
  }
}

export default App;



/* 
  <StripeProvider apiKey="pk_J3AuWyw29oLWCSzF4QQ7hPt5nvO6o">
          <div className="fullHeight">
              <button className="overlay-close-btn" onClick={this.closeOverlay}><img src="https://s3.amazonaws.com/images.disconnect.me/images/mozilla/close-icon.png" alt="Close button"/></button>
              <Elements>
                <Form toggleLoading={this.toggleLoading}/>
              </Elements>
              <div className={loadingClass}>
                <ShieldAnimation text={this.state.loadingTexts[this.state.loadingText]}/>
              </div>
          </div>
        </StripeProvider>

*/ 